import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { UpdateGOOGLE_CLIENT_ID } from "../../../Services/Admin/Addmin";
import { getCompanyApi } from "../../../Services/Superadmin/Superadmin";
import Swal from "sweetalert2";

export default function GoogleloginSetup() {
  const [webClientID, setWebClientID] = useState("");
  const [appClientID, setAppClientID] = useState("");
  const [activeTab, setActiveTab] = useState("web");
  const [companydata, setCompanydata] = useState({});
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    fetchCredentials();
  }, []);

  const fetchCredentials = async () => {
    try {
      const response = await getCompanyApi();
      if (response.status) {
        setCompanydata(response.data || {});
        setWebClientID(response.data.GOOGLE_CLIENT_ID || "");
        setAppClientID(response.data.app_GOOGLE_CLIENT_ID || "");
      }
    } catch (error) {
      // you can alert/log if needed
    }
  };

  const handleCopy = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    Swal.fire({
      icon: "success",
      title: "Copied!",
      text: "Value copied to clipboard.",
      timer: 1500,
      showConfirmButton: false,
    });
  };

  const UpdateGoogleCreditials = async () => {
    try {
      setUpdating(true);
      const data = {
        GOOGLE_CLIENT_ID: webClientID,
        app_GOOGLE_CLIENT_ID: appClientID,
      };

      const response = await UpdateGOOGLE_CLIENT_ID(data);

      if (response.status) {
        Swal.fire({
          title: "Updated!",
          text: "Google credentials updated successfully.",
          icon: "success",
          confirmButtonColor: "#0d6efd",
        });
      } else {
        Swal.fire({
          title: "Failed!",
          text: response.message || "Something went wrong",
          icon: "error",
          confirmButtonColor: "#dc3545",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Server error occurred",
        icon: "error",
        confirmButtonColor: "#dc3545",
      });
    } finally {
      setUpdating(false);
    }
  };

  const redirectUrl = window.location.origin;

  return (
    <div
      className="container-fluid "
    
    >
        <div className="card transaction-table custom-bg">
      <div className="row justify-content-center">
        <div className="col-lg-12 col-md-12">
          <div className="card shadow-sm border-0 rounded-4">
            {/* Header */}
            <div className="card-header  border-0 rounded-top-4 px-4 pt-3 pb-2">
                <div>
              <h4 className="fw-bold  mb-0">Google Login Setup</h4>
              <p className="text-muted small mb-0">
                Configure Google OAuth credentials for web and mobile
                applications.
              </p>
              </div>
            </div>

            <hr className="mt-0 mb-0" />

            <div className="card-body px-4 pt-4 pb-4">
              {/* Tabs */}
              <ul className="nav nav-tabs mb-4">
                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link ${
                      activeTab === "web" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("web")}
                  >
                    🌐 Web Google OAuth
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link ${
                      activeTab === "app" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("app")}
                  >
                    📱 App Google OAuth
                  </button>
                </li>
              </ul>

              {/* WEB TAB */}
              {activeTab === "web" && (
                <div className="border rounded-3 p-4">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="fw-semibold mb-0">
                      🌐 Web Google OAuth Credentials
                    </h5>
                    <span className="badge bg-primary-subtle text-primary border border-primary-subtle">
                      Web
                    </span>
                  </div>

                  <p className="text-muted small mb-3">
                    Use these settings to enable Google Login for your web
                    application.
                  </p>

                  <div className="p-3 bg-light border rounded mb-4">
                    <h6 className="text-primary fw-semibold mb-2">
                      Setup Instructions
                    </h6>
                    <ol className="small ps-3 mb-0">
                      <li>
                        Open{" "}
                        <a
                          href="https://console.cloud.google.com/auth"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Google Cloud Console
                        </a>
                      </li>
                      <li>Create or select a project.</li>
                      <li>Enable OAuth consent and Google Identity APIs.</li>
                      <li>Create an OAuth 2.0 Client ID for Web.</li>
                      <li>Add the following as an Authorized Redirect URI:</li>
                    </ol>

                    <div className="input-group input-group-sm mt-2">
                      <input
                        type="text"
                        className="form-control"
                        value={redirectUrl}
                        readOnly
                      />
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => handleCopy(redirectUrl)}
                      >
                        Copy
                      </button>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium">
                      Web Google Client ID
                    </label>
                    <input
                      className="form-control"
                      placeholder="Enter Web Google Client ID"
                      value={webClientID}
                      onChange={(e) => setWebClientID(e.target.value)}
                    />
                    <small className="text-muted">
                      Paste the Client ID from your Web OAuth credentials.
                    </small>
                  </div>
                </div>
              )}

              {/* APP TAB */}
              {activeTab === "app" && (
                <div className="border rounded-3 p-4">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="fw-semibold mb-0">
                      📱 App Google OAuth Credentials
                    </h5>
                    <span className="badge bg-success-subtle text-success border border-success-subtle">
                      Mobile App
                    </span>
                  </div>

                  <p className="text-muted small mb-3">
                    Use these settings to enable Google Login for your Android
                    application.
                  </p>

                  <div className="p-3 bg-light border rounded mb-4">
                    <h6 className="text-primary fw-semibold mb-2">
                      Setup Instructions
                    </h6>
                    <ol className="small ps-3 mb-0">
                      <li>
                        Open{" "}
                        <a
                          href="https://console.cloud.google.com/auth"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Google Cloud Console
                        </a>
                      </li>
                      <li>Enable Google Sign-In / Identity APIs.</li>
                      <li>Create OAuth Client for Android.</li>
                      <li>
                        Add Package Name:
                        <div className="mt-1">
                          <code className="bg-white px-2 py-1 rounded d-inline-block">
                            {companydata.PackagName || "your.package.name"}
                          </code>
                        </div>
                      </li>
                      <li>
                        Add SHA-1:
                        <div className="mt-1">
                          <code className="bg-white px-2 py-1 rounded d-inline-block">
                            {companydata.SHAKey || "YOUR:SHA1:KEY"}
                          </code>
                        </div>
                      </li>
                      <li>Copy the App Client ID and paste below.</li>
                    </ol>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium">
                      App Google Client ID
                    </label>
                    <input
                      className="form-control"
                      placeholder="Enter App Google Client ID"
                      value={appClientID}
                      onChange={(e) => setAppClientID(e.target.value)}
                    />
                    <small className="text-muted">
                      Paste the Client ID from your Android OAuth credentials.
                    </small>
                  </div>
                </div>
              )}

              {/* ACTIONS */}
              <div className="text-end mt-4">
                <button
                  className="btn btn-primary px-4"
                  onClick={UpdateGoogleCreditials}
                  disabled={updating}
                >
                  {updating ? "Updating..." : "Update Credentials"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}
